import { render, staticRenderFns } from "./propertyRat.vue?vue&type=template&id=2626892d&scoped=true"
import script from "./propertyRat.vue?vue&type=script&lang=js"
export * from "./propertyRat.vue?vue&type=script&lang=js"
import style0 from "./propertyRat.vue?vue&type=style&index=0&id=2626892d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2626892d",
  null
  
)

export default component.exports